import { Button, CountrySelect, Header, Icon } from '@/components/Generic'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { devLog } from '@/methods/devLog'
import { API_URL, GOCARDLESS_SERVICE_PATH } from '@/constants/apiUrl'
import { axiosInstance } from '@/methods/axiosConfig'
import { countriesList } from '@/components/Generic/CountrySelect/countriesList'
import { setUrlParam } from '@/methods/urlParams'
import type { GocardlessGetContextResponse } from '@/types/gocardless'

interface CountryOption {
  value: string
  label: string
  icon: string
}

export const GocardlessCountryPage = observer(() => {
  const store = useContext(StoreContext)
  const { themeId } = store.InterfaceState
  const { countryGocardlessPage: trans } = store.TranslationsState.translations

  const [country, setCountry] = useState<CountryOption | null>(null)
  const [expectedName, setExpectedName] = useState<string>('')

  const getContext = async () => {
    try {
      const { data } = await axiosInstance.get<GocardlessGetContextResponse>(
        `${API_URL}/${GOCARDLESS_SERVICE_PATH}/get-context`,
        {
          withCredentials: true,
        }
      )

      if (data?.expectedData?.accountHolder) {
        setExpectedName(data.expectedData.accountHolder)
      }

      if (data?.preselectedCountryCode) {
        const selectedValue = countriesList.find(
          (item) => item.value === data?.preselectedCountryCode
        )

        if (selectedValue) {
          handleCountry(selectedValue)
        }
      }
    } catch (error) {
      devLog('Error fetching data:', error)
    }
  }

  useEffect(() => void getContext(), [])

  const handleProceed = async () => {
    store.ScenarioState.nextPage()
  }

  const handleCountry = (country: CountryOption | null) => {
    if (country) {
      setCountry(country)
      setUrlParam('selectedCountry', country?.value)
    } else {
      setCountry(null)
    }
  }

  return (
    <div className="page-container mobile-m-0">
      <Header>{trans.header}</Header>
      <p className="generic__paragraph">{trans.confirmation}:</p>
      <div className="elavon__name-wrapper">{expectedName}</div>

      <div className="generic__spacer h-30" />

      <div className="elavon__step">
        <div className="elavon__step-icon">
          <Icon type="info" size="18px" color="var(--icon-main-color, black)" />
        </div>
        <div className="elavon__info-text-centered">
          <b>{trans.verificationDescription}:</b>
          <ul>
            <li>{trans.accountHolderName}</li>
            <li>{trans.accountIban}</li>
          </ul>
        </div>
      </div>

      <div className="generic__select-holder">
        <div className="generic__label">{trans.selectLabel}</div>
        <CountrySelect
          value={country}
          onChange={(value) => handleCountry(value as unknown as CountryOption | null)}
          showCheckmark
          placeholder={trans.placeholder}
        />
      </div>
      <div className="layout__content-container-bottom-fixed-centered">
        <Button onClick={() => handleProceed()} disabled={!country}>
          <span className="generic__button-text">{trans.proceed}</span>
        </Button>
      </div>
    </div>
  )
})
